module.exports = __webpack_public_path__ + "img/leftbicep-endo-mesomorph-female.e5e17cd2.svg";